function registerInputGroupClearButtons() {
  const inputClearButtons = document.querySelectorAll('.input-group-clear-button')

  inputClearButtons.forEach(inputClearButton => {
    inputClearButton.addEventListener('click', event => {
      const input = inputClearButton.parentNode.querySelector('input')
      if (input) {
        input.value = ''
        input.focus()
      }
    })
  })

  const queryInput = document.getElementById('searchPageSearchTerm');
  if (queryInput) {
    const queryForm = queryInput.closest('form');
    queryForm.addEventListener('submit', e => {
      e.preventDefault();
      let queryButton = queryForm.querySelector('button[type="submit"]');
      queryInput.setAttribute('disabled', 'disabled');
      queryInput.nextElementSibling.setAttribute('disabled', 'disabled');
      queryInput.parentElement.setAttribute('style', 'background-color:#e9ecef');
      queryButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>';
      window.location.search = `?q=${encodeURIComponent(queryInput.value)}`;
    });
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerInputGroupClearButtons()
})
